class FilterChips {
    constructor(element) {
        this.$filterChips = element;
        this.$filterChipsContainer = this.$filterChips.querySelector('[data-filter-chips="container"]');
        this.$filterChipsRemove = this.$filterChips.querySelector('[data-filter-chips="reset"]');
        this.$filterChipsCleanUrl = document.querySelector('[data-filter-chips="clean"]');
        this.$filterForm = document.querySelector('[data-product-filter="form"]');
        this.$filterCheckboxes = document.querySelectorAll('[data-product-filter="checkbox"]');
        this.$filterInputs = document.querySelectorAll('[data-product-filter="input"]');
        this.$filterLoader = document.querySelector('[data-product-overview="root"] .loader__item');
        this.$filterStatus = this.$filterChips.querySelector('[role="status"]');
    }

    initialize() {
        this.setEvents();
        this.removeParamsFromUrl();
    }

    // set events initial
    setEvents() {
        const checkedCheckboxes = Array.from(this.$filterCheckboxes).filter(checkbox => checkbox.checked);
        this.generateChips(checkedCheckboxes, this.$filterChipsContainer, this.$filterForm);
        this.removeChips(checkedCheckboxes, this.$filterChipsContainer, this.$filterForm);

        const filledInputs = Array.from(this.$filterInputs).filter(input => input.value !== '');
        this.generateChipsForInput(filledInputs, this.$filterChipsContainer, this.$filterForm);
        this.removeChipsForInput(filledInputs, this.$filterChipsContainer, this.$filterForm);
    }

    // generate filter chips and push it into the filter chip container
    generateChips(checked, chipsContainer, form) {
        if (checked.length > 0) {
            checked.forEach((checkbox) => {
                const label = document.querySelector('label[for="' + checkbox.getAttribute('id') + '"]');
                const labelText = label?.innerText;
                const newChip = document.createElement('button');
                const fieldnameClass = checkbox.getAttribute('data-product-filter-field').toUpperCase();
                const iconVarName = `ICON_${fieldnameClass}`;
                const iconMarkup = window[iconVarName] || '';

                newChip.className = 'product-overview__chip';
                newChip.innerHTML = iconMarkup + ' ' + labelText + ' ' + window.ICON_CLOSE;
                newChip.addEventListener('click', () => {
                    checkbox.checked = false;
                    this.showSpinner();
                    form.submit();
                });
                chipsContainer.prepend(newChip);
            });
        }
    }

    generateChipsForInput(filterInputs, chipsContainer, form) {
        if (filterInputs.length > 0) {
            filterInputs.forEach((input) => {
                const fieldnameClass = input.getAttribute('data-product-filter-field')?.toUpperCase();
                const iconVarName = `ICON_${fieldnameClass}`;
                const iconMarkup = window[iconVarName] || '';
                const newChip = document.createElement('button');

                newChip.className = 'product-overview__chip';
                newChip.innerHTML = window.ICON_SEARCH + ' ' + iconMarkup + ' ' + this.encodeInput(input.value) + ' ' + window.ICON_CLOSE;
                newChip.addEventListener('click', () => {
                    input.value = '';
                    this.showSpinner();
                    form.submit();
                });

                chipsContainer.prepend(newChip);
            });
        }
    }

    // remove all filter chips
    removeChips(checked, chipsContainer, form) {
        if (checked.length > 0) {
            this.$filterChips.classList.remove('product-overview__chips--hidden');

            this.$filterChipsRemove.addEventListener('click', () => {
                this.removeParamsFromUrl();
                this.showSpinner();

                checked.forEach((checkbox) => {
                    checkbox.checked = false;
                    form.submit();
                });
            });
        }
    }

    removeChipsForInput(filterInputs, chipsContainer, form) {
        if (filterInputs.length > 0) {
            this.$filterChips.classList.remove('product-overview__chips--hidden');

            this.$filterChipsRemove.addEventListener('click', () => {
                this.removeParamsFromUrl();
                this.showSpinner();

                filterInputs.forEach((input) => {
                    input.value = '';
                    form.submit();
                });
            });
        }
    }

    // on zero result go back to listing page
    removeParamsFromUrl() {
        if (this.$filterChipsCleanUrl) {
            this.$filterChipsCleanUrl.addEventListener('click', () => {
                const url = window.location.href;
                const index = url.indexOf('?');

                this.showSpinner();

                if (index !== -1) {
                    const cleanedUrl = url.substring(0, index);
                    window.location.href = cleanedUrl;
                } else {
                    window.location.href = url;
                }
            });
        }
    }

    showSpinner() {
        if (this.$filterLoader) this.$filterLoader.hidden = false;

        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                if (this.$filterLoader) this.$filterLoader.hidden = true;
            }
        });
    }

    updateStatus() {
        if (!this.$filterStatus) return;

        const checked = Array.from(this.$filterCheckboxes).filter(cb => cb.checked);

        const statusTemplate = this.$filterStatus.getAttribute('data-filter-status');
        const activeTemplate = this.$filterStatus.getAttribute('data-filter-status-active');
        const productCount = document.querySelector('[data-filter-count]');
        const productCountValue = productCount ? productCount.getAttribute('data-filter-count') : '0';

        if (checked.length > 0) {
            const names = checked.map(checkbox => {
                const label = document.querySelector(`label[for="${checkbox.id}"]`);
                return label ? label.innerText : '';
            }).filter(Boolean);

            let text = activeTemplate.replace('%filters%', names.join(', '));
            text = text.replace('%count%', productCountValue);

            this.$filterStatus.innerText = text;
        } else {
            let text = statusTemplate.replace('%count%', productCountValue);
            this.$filterStatus.innerText = text;
        }
    }

    encodeInput(input) {
        const encoded = document.createElement('div');
        encoded.innerText = input;
        return encoded.innerHTML;
    }
}

export {FilterChips};

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $filterChips = $context.querySelectorAll('[data-filter-chips="root"]');

        for (let i = 0; i < $filterChips.length; i++) {
            const filterChips = new FilterChips($filterChips[i]);
            filterChips.initialize();
        }
    }
});
